import * as types from "../actions/actionTypes";

const initialState = {
  currentRequestId: 0,
  data: {
    totalCount: 0,
    records: []
  },
  filters: {},
  hasMore: true,
  loading: false,
  page: 1,
  results: 24,
  selected: [],
  sort: {
    by: "",
    direction: ""
  },
  success: true
};

export default listType => {
  return (state = initialState, action) => {
    switch (action.type) {
      case types[`UPDATE_${listType}_INFINITELIST_CONFIGS`]:
        return Object.assign({}, state, action.configs);

      case types[`CLEAR_${listType}_INFINITELIST_RECORDS`]:
        return Object.assign({}, state, {
          data: initialState.data
        });

      case types[`START_GET_${listType}_INFINITELIST_RECORDS`]:
        return Object.assign({}, state, {
          currentRequestId: action.requestId,
          hasMore: true,
          loading: true,
          success: true,
          ...(action.reset
            ? {
                data: initialState.data
              }
            : [])
        });
      case types[`GET_${listType}_INFINITELIST_RECORDS`]:
        return action.requestId !== state.currentRequestId
          ? state
          : Object.assign({}, state, {
              ...action.response,
              data: {
                ...action.response.data,
                records: [
                  ...state.data.records,
                  ...(action.response.data.records || [])
                ]
              },
              hasMore:
                action.response.data.records &&
                action.response.data.records.length === state.results
            });

      case types[`UPDATE_${listType}_INFINITELIST_DATA`]:
        return Object.assign({}, state, {
          data: action.data
        });

      case types[`TOGGLE_SELECT_${listType}_INFINITELIST_RECORD`]:
        const selectedRecordId = action.record[action.recordIdKey];
        const selected =
          state.selected
            .map(rec => rec[action.recordIdKey])
            .indexOf(selectedRecordId) < 0
            ? [...state.selected, action.record]
            : state.selected.filter(
                rec => rec[action.recordIdKey] !== selectedRecordId
              );
        return Object.assign({}, state, { selected });
      case types[`CLEAR_${listType}_INFINITELIST_SELECTION`]:
        return Object.assign({}, state, { selected: [] });

      default:
        return state;
    }
  };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/InfiniteListReducer.js